import React from 'react';
import { Text } from '@chakra-ui/react';
import { Link } from 'core/routing';
import { SvgIcon } from 'components';
import { Filter } from 'icons';

export const Space = (space, column, conn) => {
  /* CustomerSpace Cell */
  const filterName = column.filterParamName || column.accessor;
  const filter = conn.filters[filterName];

  const { content, spaceType } = space;

  if (!spaceType) {
    return (
      <Text key='title' color='black'>
        Deleted User
      </Text>
    );
  }
  const spaceTypeStr = spaceType.toLowerCase();
  const { title, slug } = content;
  let path;
  if (spaceTypeStr === 'profile') {
    path = `@${slug}`;
  } else if (spaceTypeStr === 'initiative') {
    path = `+${slug}`;
  }
  const clickFilter = (e, clickedSpace) => {
    e.preventDefault();
    e.stopPropagation();
    e.nativeEvent.stopImmediatePropagation();
    filter.ClearSpaces();
    filter.AddSpace(clickedSpace);
    // eslint-disable-next-line no-param-reassign
    filter.filterField.SetSelected(true);
    conn.ApplyFilters();
  };
  // This is used for customerSpace and should be renamed space
  // Deal with linking to initiatives too.  from Space?
  return (
    <Link name={spaceTypeStr} params={{ [spaceTypeStr]: path }}>
      <Text key='title' color='black' _hover={{ color: 'blue' }}>
        {title}
        <SvgIcon
          size='small'
          icon={<Filter />}
          color='primary'
          onClick={e => clickFilter(e, space)}
        />
      </Text>
    </Link>
  );
};
